import React from 'react';
import './ContentPage.css';

function TermsOfService() {
  return (
    <section className="content-page terms-of-service">
      <div className="container">
        <h2 className="section-title">Terms of <span className="accent">Service</span></h2>
        
        <div className="content-wrapper">
          <div className="intro-section">
            <p className="intro-text">
              Welcome to OnlySnails! These Terms of Service govern your use of our website, services, and community. 
              By accessing or using OnlySnails, you agree to be bound by these Terms. Please read them carefully.
            </p>
            <p className="last-updated">
              <strong>Last Updated:</strong> March 15, 2024
            </p>
          </div>
          
          <div className="terms-section">
            <h3>1. Acceptance of Terms</h3>
            <p>
              By accessing or using our website, you acknowledge that you have read, understood, and agree to be bound by 
              these Terms of Service. If you do not agree to these Terms, please do not use OnlySnails.
            </p>
            <p>
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting 
              to the website. Your continued use of OnlySnails after any changes constitutes your acceptance of the revised Terms.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>2. User Accounts</h3>
            <p>
              To access certain features of our website, you may need to create an account. You are responsible for:
            </p>
            <ul>
              <li>Providing accurate, current, and complete information during registration</li>
              <li>Maintaining the security of your password and account</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized access to your account</li>
            </ul>
            <p>
              We reserve the right to suspend or terminate accounts that violate these Terms or for any other reason at our discretion.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>3. User Content</h3>
            <p>
              Our service allows you to post, link, store, share, and otherwise make available certain information, text, graphics, videos, or other material ("User Content"). You are solely responsible for the User Content that you post on OnlySnails.
            </p>
            <p>
              By posting User Content, you grant us a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, adapt, publish, translate, distribute, and display such content in connection with providing our service.
            </p>
            <p>
              You represent and warrant that:
            </p>
            <ul>
              <li>You own the content or have the right to use and grant us the rights as provided in these Terms</li>
              <li>The posting of your User Content does not violate the privacy rights, publicity rights, copyrights, contract rights, or any other rights of any person</li>
            </ul>
            <p>
              We reserve the right to monitor, edit, or remove any User Content for any reason, including content that we determine violates these Terms.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>4. Prohibited Activities</h3>
            <p>
              When using OnlySnails, you agree not to:
            </p>
            <ul>
              <li>Use the service in any way that violates any applicable laws or regulations</li>
              <li>Impersonate any person or entity, or falsely state or misrepresent your affiliation with a person or entity</li>
              <li>Interfere with or disrupt the service or servers or networks connected to the service</li>
              <li>Engage in any automated use of the system, such as using scripts to send comments or messages</li>
              <li>Attempt to bypass any measures designed to prevent or restrict access to the service</li>
              <li>Collect or harvest any personal data from other users</li>
              <li>Post content that is harmful, threatening, abusive, defamatory, obscene, or invasive of another's privacy</li>
              <li>Advocate for or promote irresponsible gastropod care practices or illegal activities related to snails</li>
              <li>Post content that encourages the release of non-native gastropod species into the wild</li>
              <li>Use the service for any commercial solicitation purposes without our permission</li>
            </ul>
          </div>
          
          <div className="terms-section">
            <h3>5. Intellectual Property</h3>
            <p>
              The OnlySnails service and its original content (excluding User Content), features, and functionality are and will remain the exclusive property of OnlySnails and its licensors. Our trademarks, logos, and service names may not be used without our prior written consent.
            </p>
            <p>
              We respect the intellectual property rights of others. If you believe that your work has been copied in a way that constitutes copyright infringement, please provide us with the following information:
            </p>
            <ul>
              <li>A physical or electronic signature of the copyright owner or authorized representative</li>
              <li>Identification of the copyrighted work claimed to have been infringed</li>
              <li>Identification of the material that is claimed to be infringing</li>
              <li>Your contact information (address, telephone number, and email)</li>
              <li>A statement that you have a good faith belief that use of the material is not authorized by the copyright owner</li>
              <li>A statement, under penalty of perjury, that the information in the notification is accurate</li>
            </ul>
            <p>
              Please send copyright infringement notices to: copyright@onlysnails.com
            </p>
          </div>
          
          <div className="terms-section">
            <h3>6. Disclaimer of Warranties</h3>
            <p>
              OnlySnails is provided on an "as is" and "as available" basis without any warranties of any kind. We disclaim all warranties, expressed or implied, including but not limited to the warranties of merchantability, fitness for a particular purpose, and non-infringement.
            </p>
            <p>
              We do not warrant that:
            </p>
            <ul>
              <li>The service will meet your specific requirements</li>
              <li>The service will be uninterrupted, timely, secure, or error-free</li>
              <li>The results from the use of the service will be accurate or reliable</li>
              <li>The quality of any products, services, information, or other material purchased or obtained through the service will meet your expectations</li>
            </ul>
          </div>
          
          <div className="terms-section">
            <h3>7. Limitation of Liability</h3>
            <p>
              To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from:
            </p>
            <ul>
              <li>Your access to or use of or inability to access or use the service</li>
              <li>Any conduct or content of any third party on the service</li>
              <li>Any content obtained from the service</li>
              <li>Unauthorized access, use, or alteration of your transmissions or content</li>
            </ul>
            <p>
              In no event shall our total liability to you for all claims exceed the amount paid by you, if any, for accessing our service during the twelve (12) months preceding the claim.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>8. Pet Care Disclaimer</h3>
            <p>
              While we strive to provide accurate and helpful information about gastropod care, OnlySnails is not a substitute for professional veterinary advice. The content provided on our website is for informational purposes only.
            </p>
            <p>
              We are not responsible for any harm that may come to your pets as a result of following advice found on our website. Always consult with a qualified veterinarian or exotic pet specialist for specific concerns about your gastropods' health.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>9. Indemnification</h3>
            <p>
              You agree to defend, indemnify, and hold harmless OnlySnails, its affiliates, licensors, and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors, and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms or your use of the service.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>10. Governing Law</h3>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law provisions. You agree to submit to the personal and exclusive jurisdiction of the courts located in San Mateo County, California.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>11. Severability</h3>
            <p>
              If any provision of these Terms is held to be invalid or unenforceable, such provision shall be struck and the remaining provisions shall be enforced to the fullest extent under law.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>12. Termination</h3>
            <p>
              We may terminate or suspend your account and access to OnlySnails immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
            </p>
            <p>
              Upon termination, your right to use the service will immediately cease. All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity, and limitations of liability.
            </p>
          </div>
          
          <div className="terms-section">
            <h3>13. Contact Us</h3>
            <p>
              If you have any questions about these Terms, please contact us at:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> legal@onlysnails.com</p>
              <p><strong>Postal Address:</strong> OnlySnails Headquarters, 123 Gastropod Lane, Shell City, CA 94025</p>
              <p><strong>Phone:</strong> (555) 123-4567</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TermsOfService;
